import { useCallback, useEffect, useMemo, useState } from "react";
import Switch from "@mui/material/Switch";
import { Link } from "react-router-dom";
import DataTable from "../_Components/DataTable";
import ApiPromocategorycommision from "../../../core/api/api.promocategorycommision";
import ApiAmusementService from "../../../core/api/api.amusementService";
import SwalMessage from "../_Components/SwalMessage";
import _ from "lodash";
import { Button, Col, Modal, Row } from "react-bootstrap";
import * as XLSX from "xlsx";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import Swal from "sweetalert2";
function DataGridAmusementServicePromoCategory({ data, setSelectedPromoCategoryCommision, setShowModalPromoCategoryCommision, cities }) {
  const [showModalUploadFile, setShowModalUploadFile] = useState();
  const [selectedFile, setSelectedFile] = useState();
  const [selectedRowId, setSelectedRowId] = useState();
  const [selectedPromoCategoryCommissionName, setSelectedPromoCategoryCommissionName] = useState("");
  const [isUploading, setIsUploading] = useState(false); //loading
  const [selectedCities, setSelectedCities] = useState([{
    "value": 899,
    "label": "کیش"
  }])
  const [isDownloading, setIsDownloading] = useState(false); //loading
  const [selectedRowGrid, setSelectedRowGrid] = useState(false);
  const [listAmusementGroup, setListAmusementGroup] = useState([]);
  const [selectedAmusementGroup, setSelectedListAmusementGroup] = useState([]);
  const handleChange = (name) => (event) => {
    updatePromoCategoryCommisionStatus(name, 0);
  };
  const handleChangeIsDefault = (name) => (event) => {
    updatePromoCategoryCommisionStatus(name, 1);
  };
  async function updatePromoCategoryCommisionStatus(item, flag) {
    const response = await ApiPromocategorycommision.updatePromoCategoryCommisionStatusOrIsDefault({
      id: item.id,
      isActive: flag == 0 ? !item.isActive : item.isActive,
      isDefault: flag == 1 ? !item.isDefault : item.isDefault,
    });
    if (response.succeeded == true) document.getElementById("submitButton").click();

    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }

  useEffect(() => {
    (async () => {
      const data = (await ApiAmusementGroup.getAll({ pageSize: 200, pageNumber: 1 })).data;
      setListAmusementGroup(data)
    })()
  }, [])

  //نمایش داده ها روی اکسل
  const exportToExcel = async (id, selectedCities) => {
    setIsDownloading(true)
    if (!id) return;
    //  گروه تخفیف
    let promoResponse = await ApiPromocategorycommision.getPromoCategoryCommissionAmusementServiceById(id); //get PromoCategoryAmusmentService List
    let commissions = promoResponse.getPromoCategoryCommisionByIdViewModel;
    let discounts = promoResponse.getPromoCategoryByIdViewModel;
    //  لیست سرویس‌ها و آیتم‌ها
    let amusementResponse = await ApiAmusementService.getAllServices({
      groupIdList: selectedAmusementGroup.map(city => city.value).join(","),
      cityIdList: selectedCities.map(city => city.value).join(",")
    });

    const services = amusementResponse.map((item) => ({
      serviceId: item.id,
      serviceName: item.name,
      amusementServiceReserveItems: item.amusementServiceReserveItems,
    }));

    const rows = [];

    services.forEach((service) => {
      service.amusementServiceReserveItems.forEach((item) => {
        // پیدا کردن کمیسیون مربوطه
        let commission = commissions.find(
          (x) => x.amusementServiceId === service.serviceId,
        );
        let commissionData = commission
          ? JSON.parse(commission.amusementServiceFormFieldIds)
          : [];
        let reserveItemCommission = commissionData.find((n) => n.id === item.id.toString());
        // پیدا کردن تخفیف مربوطه
        let discount = discounts.find(
          (x) => x.amusementServiceId === service.serviceId,
        );
        let discountData = discount
          ? JSON.parse(discount.amusementServiceFormFieldIds)
          : [];
        let reserveItemDiscount = discountData.find((n) => n.id === item.id.toString());

        rows.push({
          ServiceId: service.serviceId,
          ItemId: item.id,
          تفریح: service.serviceName,
          آیتم: item.title,
          'قیمت اصلی': item.originalPrice,
          قیمت: item.price,
          'پرداختی به تامین کننده': item.supplierSettlementPrice,
          "تخفیف به تومان": reserveItemDiscount?.discountprice || "",
          "کمیسیون به تومان": reserveItemCommission?.discountpriceCommision || "",
        });
      });
    });


    const worksheet = XLSX.utils.json_to_sheet(rows);

    // تنظیم عرض ستون‌ها)
    worksheet["!cols"] = [
      { wch: 10 }, // ServiceId
      { wch: 10 }, // ItemId
      { wch: 20 }, // تفریح
      { wch: 40 }, // آیتم
      { wch: 15 },//قیمت
      { wch: 15 },//قیمت اصلی
      { wch: 20 },//پرداختی به تامین کننده
      { wch: 20 }, // تخفیف به تومان
      { wch: 20 }, // کمیسیون به تومان
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Commissions");
    XLSX.writeFile(workbook, `promo-commissions-${id}.xlsx`);
    setIsDownloading(false)
  };
  // وقتی کاربر فایل را انتخاب می‌کند
  const handleFileSelect = (e) => {
    const file = e.target.files[0]; //  اولین فایل
    if (!file.name.includes("commissions")) {
      Swal.fire({
        title: "فایل انتخاب شده مربوط به کمیسیون ها نمی باشد!", icon: "error", showConfirmButton: true, confirmButtonText: "فهمیدم", customClass: {
          actions: "my-actions",
          confirmButton: "order-2 btn btn-success px-5",
        },
      });
      e.target.value = null; // ریست کردن input فایل
      return;
    }
    if (file) {
      setSelectedFile(file);
    }
  };
  //ارسال فایل اکسل به سرور  
  const handleUpload = async () => {
    if (!selectedFile) {
      Swal.fire({
        title: "لطفاً فایل را انتخاب کنید!", icon: "error", showConfirmButton: true, confirmButtonText: "فهمیدم", customClass: {
          actions: "my-actions",
          confirmButton: "order-2 btn btn-success px-5",
        },
      });
      return;
    }
    try {
      setIsUploading(true);
      const formData = new FormData();
      formData.append("file", selectedFile); // فایل انتخاب‌شده
      formData.append("promoCategoryCommissionId", selectedRowId); // 
      const response = await ApiPromocategorycommision.addOrEditPromoCategoryCommisionAmusmentServiceByExcel(formData);
      const title = response.message.split(".")[0]
      const message = response.message.substr(response.message.indexOf("."))
      Swal.fire({
        title, text: message, icon: "success", showConfirmButton: true, confirmButtonText: "فهمیدم", customClass: {
          actions: "my-actions",
          confirmButton: "order-2 btn btn-success px-5",
        },
      }); handleCloseUploadFileModal();
    }
    catch (err) {
      Swal.fire({
        title: "خطا در آپلود فایل", text: err?.message || "", icon: "error", showConfirmButton: true, confirmButtonText: "فهمیدم", customClass: {
          actions: "my-actions",
          confirmButton: "order-2 btn btn-success px-5",
        },
      });
    }
    finally { setIsUploading(false); }
  };
  const handleCloseUploadFileModal = () => {
    setShowModalUploadFile(false);
    setSelectedFile(null);
  }
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "شماره",
      minWidth: 50,
    },
    {
      accessor: "name",
      Header: "نام گروه کمیسیون",
      minWidth: "100px",
    },
    {
      Header: "گروه تخفیف",
      minWidth: "100px",
      Cell: ({ row }) => row?.original?.promoCategory.name + "",
    },
    {
      Header: "وضعیت گروه",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.isActive}
            //checked={state.checkedA}
            value="row.original.isActive"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            onChange={handleChange(row.original)}
          />
        </div>
      ),
    },
    {
      Header: "حالت پیش فرض",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.isDefault}
            //checked={state.checkedA}
            value="row.original.isDefault"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            onChange={handleChangeIsDefault(row.original)}
          />
        </div>
      ),
    },
    {
      accessor: "createdPersianTime",
      Header: "زمان ایجاد",
      minWidth: "150px",
      Cell: ({ row }) => (
        <div className="ltr">
          {row.original?.createdPersianTime != null ? row.original?.createdPersianTime : "-"}
        </div>
      ),
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش"
            onClick={() => {
              setSelectedPromoCategoryCommision(row.original)
              setShowModalPromoCategoryCommision(true)
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
          {/* ویرایش */}
          <Link
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش آیتم های گروه کمیسیون"
            to={`/CreateEditAmusementServicePromoCategoryCommision/${row.original.id}`}
          >
            <i className="fa fa-list text-small"></i>
          </Link>
          <Button //دکمه ویرایش بالارو روی فایل اکسل باز می کنه
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="دانلود فایل کمیسیون ها"
            onClick={() => setSelectedRowGrid(row.original)}
          >
            <i className="fa fa-download text-small"></i>
          </Button>
          <Button //آپلود فایل بالا
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="آپلود فایل کمیسیون ها"
            onClick={() => {
              setShowModalUploadFile(true);
              setSelectedRowId(row.original.id);
              setSelectedPromoCategoryCommissionName(row.original.name);
            }}
          >
            <i className="fa fa-upload text-small"></i>
          </Button>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };

  const handleCloseFileModal = useCallback(() => {
    setSelectedRowGrid(null)
  }, [])
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
      {/* کدهای مربوط به مدال آپلود فایل تخفیف */}
      <Modal show={showModalUploadFile} onHide={handleCloseUploadFileModal}>
        <Modal.Header closeButton>
          <Modal.Title>آپلود فایل کمیسیون های  {selectedPromoCategoryCommissionName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input type="file" accept=".xlsx" onChange={handleFileSelect} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseUploadFileModal}>
            بستن
          </Button>
          <Button
            variant="primary"
            onClick={handleUpload}
            disabled={isUploading}   //  در زمان آپلود
          >
            {isUploading ? "در حال ثبت..." : "ثبت"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={selectedRowGrid} onHide={handleCloseFileModal}>
        <Modal.Header closeButton>
          <Modal.Title>دانلود فایل کمیسیون های {selectedRowGrid?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="mb-5">
              <SelectComponent
                className=" mt-5"
                placeholder="شهر"
                options={cities}
                isMulti
                onChange={(selectedCities) => {
                  setSelectedCities(selectedCities)
                }}
                value={selectedCities}
              />

            </Col>
            <Col className="mb-5">
              <SelectComponent
                className=" mt-5"
                placeholder="دسته"
                options={listAmusementGroup.map((item) => ({
                  value: item.id,
                  label: item.title,
                }))}
                isMulti
                onChange={(selectedAmusementGroup) => {
                  setSelectedListAmusementGroup(selectedAmusementGroup)
                }}
                value={selectedAmusementGroup}
              />

            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseFileModal}>
            بستن
           </Button>
          <Button
            variant="primary"
            onClick={() => {
              exportToExcel(selectedRowGrid.id, selectedCities)
            }}
            disabled={isDownloading}   //  در زمان دانلود
            className="w-25 mt-2"
          >
            {isDownloading ? "در حال دانلود..." : "دانلود"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default DataGridAmusementServicePromoCategory;
